import React from "react"

const PageTitle = ({ children }) => (
  <h3 className="page title bold">{children}</h3>
)

export default PageTitle



// WEBPACK FOOTER //
// ./src/medium/PageTitle.js